module.exports = __webpack_public_path__ + "static/media/mute-key.9e408916.svg";